import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, message, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem } from "../../../Components/Items";
import AgregarRemolque from "./AgregarRemolque/AgregarRemolque";
import EditarRemolque from "./EditarRemolque/EditarRemolque";

class Remolques extends Component {
    state = {
        todasRemolques: [],
        modalAgregarRemolque: false,
        modalEditarRemolque: false,
        modalEditarRemolqueId: null,
        loading: false
    }
    componentDidMount() {
        this.consultarRemolques();
    }

    consultarRemolques() {
        this.setState({ loading: true })
        axios
            .post(
                "remolques/selectTodosRemolques",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false })
                if (res.data.success === 2) {
                    this.setState({
                        todasRemolques: res.data.remolques.map(value => {
                            return { ...value, subtipoRemolque: (value.subtiporemolquesat.Clave + ' - ' + value.subtiporemolquesat.Descripcion), accion: { _id: value._id, estado: value.estado } }
                        }),
                    });
                }
            });
    }

    deshabilitarRemolque(value) {
        axios
            .post(
                "remolques/deshabilitarRemolque",
                { remolqueId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Remolque deshabilitado");
                } else {
                    message.error("Sucedio un error y no se pudo deshabilitar");
                }
                this.consultarRemolques();
            });
    }
    habilitarRemolque(value) {
        axios
            .post(
                "remolques/habilitarRemolque",
                { remolqueId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Remolque habilitado");
                } else {
                    message.error("Sucedio un error y no se pudo habilitar");
                }
                this.consultarRemolques();
            });
    }

    abrirAgregarRemolque() {
        this.setState({ modalAgregarRemolque: true });
    }
    cerrarAgregarRemolque() {
        this.setState({ modalAgregarRemolque: false });
        this.consultarRemolques();
    }
    abrirEditarRemolque(id) {
        this.setState({ modalEditarRemolque: true, modalEditarRemolqueId: id });
    }
    cerrarEditarRemolque() {
        this.setState({ modalEditarRemolque: false });
        this.consultarRemolques();
    }
    render() {
        const columns = [
            {
                title: "Descripcion",
                dataIndex: "descripcion",
                key: "descripcion",
                sorter: (a, b) => {
                    if (a.descripcion < b.descripcion) {
                        return -1;
                    }
                    if (a.descripcion > b.descripcion) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "descripcion",
            },
            {
                title: "Placa",
                dataIndex: "placa",
                key: "placa",
                sorter: (a, b) => {
                    if (a.placa < b.placa) {
                        return -1;
                    }
                    if (a.placa > b.placa) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "placa",
            },
            {
                title: "Subtipo Remolque",
                dataIndex: "subtipoRemolque",
                key: "subtipoRemolque",
                sorter: (a, b) => {
                    if (a.subtipoRemolque < b.subtipoRemolque) {
                        return -1;
                    }
                    if (a.subtipoRemolque > b.subtipoRemolque) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "subtipoRemolque",
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                align: "center",
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    className: "acciones-sin-hover",
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, index) => {
                    let buttons = [];

                    // Botón Editar
                    if (this.props.permisoEditarRemolque) {
                        buttons.push(
                            <Tooltip title="Editar Remolque" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    key={`editar-${index}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.abrirEditarRemolque(value._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    // Botón Habilitar/Deshabilitar
                    if (this.props.permisoDeshabilitarRemolque) {
                        if (value.estado === 1) {
                            buttons.push(
                                <Popconfirm
                                    key={`deshabilitar-${index}`}
                                    title="Seguro que quieres deshabilitar este remolque"
                                    onConfirm={() => this.deshabilitarRemolque(value._id)}
                                    okText="Si"
                                    cancelText="No"
                                >
                                    <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            lima
                                            icon={<CheckCircleOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        } else {
                            buttons.push(
                                <Popconfirm
                                    key={`habilitar-${index}`}
                                    title="Seguro que quieres habilitar este remolque"
                                    onConfirm={() => this.habilitarRemolque(value._id)}
                                    okText="Si"
                                    cancelText="No"
                                >
                                    <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<StopOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ]
        return (
            <>
                <PageHeader
                    title="Remolques"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={ this.props.permisoAgregarRemolque &&
                        <ButtonItem
                            type="primary"
                            key="agregarRemolque"
                            olivo
                            onClick={this.abrirAgregarRemolque.bind(this)}
                             className="botonAgregar"
                        >
                            Agregar Remolque
                        </ButtonItem>
                    }
                />
                <TableItem 
                    loading={this.state.loading} 
                    size='small' 
                    dataSource={this.state.todasRemolques} 
                    columns={columns} 
                    onRow={(record) => ({
                        onDoubleClick: () => this.abrirEditarRemolque(record._id),
                      })}
                />
                    <AgregarRemolque
                        visible={this.state.modalAgregarRemolque}
                        cerrarAgregarRemolque={this.cerrarAgregarRemolque.bind(
                            this
                        )}
                    />
                    <EditarRemolque
                        visible={this.state.modalEditarRemolque}
                        id={this.state.modalEditarRemolqueId}
                        cerrarEditarRemolque={this.cerrarEditarRemolque.bind(this)}
                    />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoAgregarRemolque:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675096a4798d4e0043687255"
      )?.activado,
      permisoEditarRemolque:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675096cb798d4e0043687256"
      )?.activado,
      permisoDeshabilitarRemolque:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675096f0798d4e0043687257"
      )?.activado,
    };
};

export default connect(mapStateToProps)(Remolques);